export enum TypeaheadFilterVariant {
  Chips = "chips",
  Text = "text",
}

export enum TypeaheadChipDisplayMode {
  All = "all",
  Squashed = "squashed",
}
